import axiosInstance from './apis';


export const getProducts = async(query) =>{
  return await axiosInstance.post(`/accounts/get-items-by-search`,query)
}
